<sharry-header></sharry-header>
<div class="terms-and-privacy__wrapper">
  <div class="terms-and-privacy">
    @if (busy) {
      <sharry-loading></sharry-loading>
    } @else {
      <div
        class="markdown"
        [innerHTML]="text | safe: 'html'"></div>
    }
  </div>
</div>

<sharry-footer class="is-not-mobile"></sharry-footer>
